import { render, staticRenderFns } from "./SingleMember.vue?vue&type=template&id=1ab669c0"
import script from "./SingleMember.vue?vue&type=script&lang=js"
export * from "./SingleMember.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports